export default __webpack_public_path__ + "static/media/magnifying-glass.9d9f2e23.svg";